import state from "./state";
import mutations from "./mutations";

const homeOverview = {
  namespaced: true,
  state,
  mutations,
};

export default homeOverview;
